import { useRef } from "react";
import { useIsoMorphicEffect as n } from "./use-iso-morphic-effect.js";
function s(e) {
  let r = useRef(e);
  return n(() => {
    r.current = e;
  }, [e]), r;
}
export {
  s as useLatestValue
};
